// import "./scss/dark.scss"

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueRouter from "vue-router"

// @ts-ignore
import Sortable from "vue-sortable"
import BootstrapVue from "bootstrap-vue"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

// @ts-ignore
import shortkey from "vue-shortkey"
import { formatDateMixin } from "@/mixins/formatDateMixin"
import { calculatedValueDisplay } from "@/mixins/calculatedValueDisplay"
import { filterMixin } from "@/mixins/filtering"
import { utils } from "@/mixins/utils"
import { controls } from "@/mixins/controls"
import { formatFieldsMixin } from "@/mixins/formatFieldsMixin"
import { vSelectOpenUpMixin } from "@/mixins/v-select"
import PortalVue from "portal-vue"

// @ts-ignore
import VueSanitize from "vue-sanitize"
import sanitizeOptions from "@/utils/sanitizeOptions"
import "bootstrap-vue/dist/bootstrap-vue.css"

import Quill from "quill"
import Placeholder from "@/utils/Placeholder"
import PlainSpaceText from "@/utils/PlainSpaceText"

// @ts-ignore
import MagicUrl from "quill-magic-url"

Vue.config.productionTip = false

store.commit("setRouter", router)

Vue.use(VueRouter)
Vue.use(BootstrapVue, { BModal: { titleTag: "h3" } })
Vue.use(shortkey, { prevent: [".prevent-shortcut"] })
Vue.mixin(formatDateMixin)
Vue.mixin(calculatedValueDisplay)
Vue.mixin(filterMixin)
Vue.mixin(utils)
Vue.mixin(controls)
Vue.mixin(formatFieldsMixin)
Vue.mixin(vSelectOpenUpMixin)
Vue.use(Sortable)
Vue.use(PortalVue)

/**
 * Vue Sanitize used for displaying text from rich text areas.
 */
Vue.use(VueSanitize, sanitizeOptions)

Vue.config.errorHandler = async function (err) {
	if (typeof window.newrelic !== "undefined" && typeof window.newrelic.noticeError === "function") {
		window.newrelic.noticeError(err)
	}
	// eslint-disable-next-line no-unsafe-finally
	throw err
}

Quill.register("modules/magicUrl", MagicUrl)
Quill.register(Placeholder)
Quill.register("blots/text", PlainSpaceText, true)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app")
